import ErrorIcon from '@mui/icons-material/Error';
import WarningIcon from '@mui/icons-material/Warning';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import PropTypes from 'prop-types';

export default function PopUpHandle({ open, handleClose, errorCode, error }) {

    let titleStyle = { padding: '1em' };
    let IconComponent = null;

    let buttonColor = '#ED5565'; // Default to error color
    if (String(errorCode).startsWith('4')) {
        buttonColor = '#ffbf00'; // Warning color
    }

    if (String(errorCode).startsWith('5')) {
        titleStyle = { backgroundColor: '#ED5565', height: '2em', padding: '0.3em', color: 'white' };

        IconComponent = ErrorIcon;
    } else if (String(errorCode).startsWith('4')) {
        titleStyle = { backgroundColor: '#ffbf00', height: '2em', padding: '0.3em', color: 'white' };

        IconComponent = WarningIcon;
    }

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            PaperProps={{
                style: {
                    backgroundColor: "white",
                    width: '25%',
                    maxWidth: 'none',
                    height: 'auto',
                    maxHeight: '80vh',
                },
            }}
            BackdropProps={{
                style: {
                    backgroundColor: 'transparent',
                },
            }}
        >
            <DialogTitle style={titleStyle}>
                {IconComponent && <IconComponent style={{ verticalAlign: 'middle', marginRight: '0.5em' }} />}
                {String(errorCode).startsWith('5') ? 'Error' : 'Warning'}
            </DialogTitle>
            <DialogContent style={{ padding: '1em', overflow: 'hidden' }}>
                <DialogContentText style={{ textAlign: "center", whiteSpace: 'pre-wrap', overflow: 'hidden', wordBreak: 'break-word' }}>
                    {error}
                </DialogContentText>
            </DialogContent>
            <DialogActions style={{ justifyContent: 'center' }}>
                {/*  <Button onClick={handleClose} style={buttonStyle}>Ok</Button> */}
                <Button variant='contained' sx={{
                    minWidth: '1em', // Override or add specific styles after spreading base styles
                    minHeight: '1em',
                    padding: '4px 9px 4px 7px', // Top, Right, Bottom, Left in pixels
                    backgroundColor: buttonColor, // Apply dynamic background color
                    color: 'white', // Text color
                    '&:hover': {
                        backgroundColor: buttonColor, // Maintain same color on hover
                    },
                }}
                    onClick={handleClose} >Ok</Button>
            </DialogActions>
        </Dialog>
    );
}

PopUpHandle.propTypes = {
    open: PropTypes.bool.isRequired,
    handleClose: PropTypes.func.isRequired,
    errorCode: PropTypes.number.isRequired,
    error: PropTypes.string.isRequired,
};
